// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"379":"017f4a0b","569":"50f3c131","653":"54ba5902","657":"e1101252","686":"90ab22af","777":"b6b2c06e","806":"ca517617","993":"5c4f8951","998":"1d80b867"}[chunkId] + ".js";
};